export default __webpack_public_path__ + "static/media/404.cb0a7956.svg";